module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAcCAYAAAAEN20fAAAABHNCSVQICAgIfAhkiAAAAVBJREFUSInN1y9Pw0AcxvHvb91rwK5u7V4CZlOIJqTti5ghA8e7wBDAMAMO1ymwQ4CYGPbmOjHcDAk4OAxboPvbpb3jUXeXu8snT86cQ86EzfCo4Tae/Jo/UWP1kvf8qlTzbI6bcRvhCgDhoygEQCUn4vpnepr0k7siIbIj4qxIBGzRSNSKOmUjYEMjUSvqCHJRNmItxCRiJcQ0YinEBmIB8huh0ce9fu/SBOIPxCZiDrGNAJCwGZ5XpHICoLW+RxiYRgC3VUFmCEQkAALTCo2WqkZ3BWmLCFrrB0uN3PybN+IAqFQNPNebChIIEniuN1WpMtqMMxtkMb7rv6tUPRuHZDHAgUmMk12whVmA2MIshdjArISYxqyFzDB+zX9FOCwTsxECoMZqWDZmK8gyTN2tT0bpaFgUZOt/DUDymHSBDvApX/JWFGLnxPvxXtF3fgN6L8nL9Xz65wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Laboratory/left.png
// module id = +72f
// module chunks = 1 2